
<template>
  <div>
    <v-card flat>
      <v-card-title>
        <span class="font-weight-light">Escolha as faturas a serem pagas:</span>
      </v-card-title>
      <v-card-text>
        <!-- <v-row>
          <v-text-field prepend-inner-icon="mdi-magnify" label="Buscar" class="pt-0 px-5"></v-text-field>
        </v-row> -->
        <!-- <v-btn class="px-1 mt-3" primary small @click="putMaxValue">Pagar valor maximo das faturas</v-btn> -->
        <v-data-table v-model="selected_vrts" :loading="loading.vrt_transactions" show-select :headers="headers" :items="vrt_transactions" :single-select="single_select">
          <template v-slot:item.data-table-select="{ item, isSelected, select }">
            <div class="d-flex align-center">
              <v-simple-checkbox :disabled="item.attributes.pay_status != 'available'" :value="isSelected" @input="select($event)"></v-simple-checkbox>
            </div>
          </template>
          <template v-slot:item.order_id="{item}">
            <div class="d-flex align-center">
              {{ item?.attributes?.order_id || item?.attributes?.external_order_id }}
              <v-btn small icon @click="goToOrder(item.attributes)">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:item.attributes.DateExpired="{item}">
            {{ $moment(item.attributes.DateExpired).format('DD/MM/YYYY') }}
          </template>
          <template v-slot:item.payment_ammount="{item}">
            <div class="d-flex">
              <span class="text-no-wrap success--text text--darken-2">
                {{Number(item.attributes.ammount_payed).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </span>
              <span class="mx-1 text-no-wrap"> / </span> 
              <span class="text-no-wrap black--text text--darken-2">
                {{Number(item.attributes.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </span>
            </div>

          </template>
          <template v-slot:item.attributes.payment_description="{item}">
            {{ !!item.attributes.payment_description ? item.attributes.payment_description : '-' }}
          </template>
          <template v-slot:item.rest="{item}">
            <span class="text-no-wrap">
              <b class="error--text text--darken-1">
                {{( Number(item.attributes.ammount) - Number(item.attributes.ammount_payed) ).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </b>
            </span>
          </template>
          <template v-slot:item.input="{item}">
            <v-text-field :rules="[ ...not_zero, ...positive_number, value => Number(value?.replace(/,/g, ''))  <= Number(item.attributes.ammount - item.attributes.ammount_payed).toFixed(2) || 'Valor maior que o valor restante!']" @input="emitData" v-model="item.paying_ammount" v-money="money" 
              v-if="vrt_transaction_ids.includes(item.id)" label="(R$) Valor base">
            </v-text-field>
            <span v-if="!vrt_transaction_ids.includes(item.id)">--</span>
          </template>
          <template v-slot:item.juros_input="{item}">
            <v-text-field
              v-if="vrt_transaction_ids.includes(item.id)"
              v-model="item.paying_juros"
              v-money="money"
              label="(R$) Juros"
              :rules="[...positive_number]"
              @input="emitData"
            />
            <span v-if="!vrt_transaction_ids.includes(item.id)">--</span>
          </template>

          <template v-slot:item.attributes.processing="{item}">
            <v-chip 
              small 
              :color="['available', 'done'].includes(item.attributes.pay_status) ? 'success' : 'orange'" 
              text-color="white"
            >{{ pay_status_map[item.attributes.pay_status] }}</v-chip>
          </template>


          <template v-slot:item.actions="{item}">
            <v-btn 
              small 
              color="primary" 
              text-color="white"
              icon
              @click="actionInfosDialog(item, true)"
            ><v-icon>mdi-information</v-icon></v-btn>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>

    <dialog-loading v-if="loading_selected_item" ></dialog-loading>
    <v-dialog v-model="action_dialog" v-if="action_dialog &&!loading_selected_item" max-width="800px">
      <v-card>
        <v-card-title>
          Fatura: {{ selected_item.attributes.comment }}
        </v-card-title>
        <v-card-text class="py-0" :style="selected_item.infos.length > 1 ? 'overflow-y: auto; height:60vh' : ''">
          <v-divider v-if="selected_item.infos[0].vrt_payment"></v-divider>
          <span v-if="selected_item.infos.length == 0">Sem histórico</span>
          <div v-for="(item, idx) in selected_item.infos" :key="idx">
            <v-divider v-if="idx"></v-divider>
            <v-list dense >
              <!--  INFORMAÇÕES PAGAMENTO -->
              <v-subheader v-if="item.vrt_payment"><h3>Informações do pagamento {{idx + 1}}</h3></v-subheader>
              <v-list-item-group  v-if="item.vrt_payment">
                <v-list-item>
                  <v-list-item-content>Status do pagamento <v-list-item-title> 
                    <v-chip x-small :class="['my-1', status_map[item.payment.status_id].color]" >{{status_map[item.payment.status_id].title}}</v-chip>
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Valor do pagamento <v-list-item-title> R$ {{item.vrt_payment.paying_ammount}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!['pix', 'bill'].includes(item.payment.kind)">
                  <v-list-item-content>Tipo do pagamento <v-list-item-title> {{payment_map[item.payment.kind]}} </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <!--  INFORMAÇÕES PAGAMENTO -->
              
              <!-- INFORMAÇÕES BOLETO -->
              <v-subheader v-if="item.bill"><h3>Boleto</h3></v-subheader>
              <v-list-item-group v-if="item.bill">
                <v-list-item>
                  <v-list-item-content>Número do documento <v-list-item-title> {{item.bill.nf_number ? item.bill.nf_number : '-'}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Nosso número <v-list-item-title> {{item.bill.our_number ? item.bill.our_number : '-'}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Vencimento do boleto <v-list-item-title> {{$moment(item.bill.nf_due).format('LL')}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Status do boleto <v-list-item-title> 
                    {{ status_map[item.bill.status_id].title }} 
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
                
                <v-list-item v-if="item.bill.canceled_at">
                  <v-list-item-content>Data de cancelamento <v-list-item-title> 
                    {{ $moment(item.bill.canceled_at).format('LL') }} 
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
                
              </v-list-item-group>
              <!-- INFORMAÇÕES BOLETO -->
  
              <!-- INFORMAÇÕES PIX -->
              <v-subheader v-if="item.pix"><h3>Pix</h3></v-subheader>
              <v-list-item-group v-if="item.pix">
                <v-list-item>
                  <v-list-item-content>ID do pix <v-list-item-title> {{item.pix.id}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Chave <v-list-item-title> {{item.pix.company_key}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Status do pix <v-list-item-title> 
                    {{ pix_status_map[item.pix.pix_status] }} 
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <!-- INFORMAÇÕES PIX -->
              
            </v-list>

          </div>
          <h3 class="d-flex justify-center pb-6 pt-5" v-if="selected_item.infos.length == 0">Sem histórico</h3>
          
          <v-divider v-if="selected_item.infos[0].vrt_payment"></v-divider>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small class="error" @click="actionInfosDialog(null, false)">fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Api from '@/api/index';
import { mapState } from 'vuex'
import cimentao_links from "@/mixins/cimentao_links";
import { VMoney } from 'v-money'
import validations from "@/mixins/validations.js"

export default {
  name: 'VrtSelection',
  directives: { money: VMoney },
  mixins: [ cimentao_links, validations ],
  props: {
    client_id:{
      type: [String, Number],
      default: null,
    },
    payment_total:{
      type: [String, Number],
      default: "0.00",
    },
    manual_values:{
      type: Boolean,
      default: false,
    },
    single_select: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected_vrts: [],
      vrt_transactions: [],
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
      loading: {
        vrt_transactions: false
      },
      pay_status_map:{
        available: 'Disponível', 
        waiting_payment: 'Aguardando pagamento', 
        processing: 'Processando', 
        done: 'Finalizado', 
        error: 'Erro',
        protested: 'Protestado',
      },
      action_dialog: false,
      selected_item: {},
      loading_selected_item: false,
      status_map: {
        2:  {title: "Inativo", color: 'error'},
        5:  {title: 'Cancelado', color: 'error'},
        6:  {title: "Aberto", color: 'primary'},
        7:  {title: "Pago", color: 'success'},
        11: {title: "Computado", color: 'success'},
        16: {title: "Concluído", color: 'primary'},
      },
      pix_status_map: {
        "cancelled": 'Cancelado', 
        "expired": 'Expirado', 
        "pending": 'Pendente', 
        "error": 'Erro', 
        "approved": 'Aprovado',

      },
      payment_map: {
        "envelope": 'Envelope',
        "deposit": 'Depósito',
        "bill": 'Boleto',
        "bonus": 'Bonus',
        "pix": 'Pix'

      }
    }
  },
  computed: {
    headers(){
      if(!this.manual_values){
        return [
          { text: "Pedido", value: "order_id" },
          { text: "Validade", value: "attributes.DateExpired" },
          { text: "Forma de Pagamento", value: "attributes.payment_description", width:"100px" },
          { text: "Comentário", value: "attributes.comment" },
          { text: "Pago / Total", value: "payment_ammount" },
          { text: "Valor restante", value: "rest" },
          { text: "Valor base", value: "input", width:"150px"},
          { text: "Juros", value: "juros_input", width:"150px"},
          { text: "Status", value: "attributes.processing", align: 'center' },
          { text: "Ações", value: "actions", align: 'center' },
        ]
      }else{
        return [
          { text: "Pedido", value: "order_id" },
          { text: "Validade", value: "attributes.DateExpired" },
          { text: "Forma de Pagamento", value: "attributes.payment_description", width:"100px" },
          { text: "Comentário", value: "attributes.comment" },
          { text: "Pago / Total", value: "payment_ammount" },
          { text: "Valor restante", value: "rest" },
          { text: "Status", value: "attributes.processing", align: 'center' },
          { text: "Ações", value: "actions", align: 'center' },
        ]
      }
    },
    vrt_transaction_ids(){
      return this.selected_vrts.map(el => el.id)
    },
    selected_vrts_ammount(){
      return this.selected_vrts.reduce((sum, vrt) => sum + (vrt.attributes.ammount - vrt.attributes.ammount_payed), 0).toFixed(2)
    },
    total_debt(){
      return this.vrt_transactions.reduce((sum, vrt) => sum + (vrt.attributes.ammount - vrt.attributes.ammount_payed), 0).toFixed(2)
    },
    paying_vrts(){
      return this.selected_vrts.map(el => ({
        vrt_transaction_id: el.id,
        paying_ammount: Number(el.paying_ammount?.toString()?.replace(/,/g, '') || 0),
        paying_juros: Number(el.paying_juros?.toString()?.replace(/,/g, '') || 0),
      }))
    },
  },
  methods: {
    actionInfosDialog(item = null, action = false){
      this.action_dialog = action
      this.selected_item = item
      
      if(action) this.getItemInfos(item.attributes.id)
    },
    getItemInfos(id){
      this.loading_selected_item = true
      Api.AssignedVrtPayment.show(id).then(r=> this.selected_item = {...this.selected_item, infos: r.data}).catch(err=>{
        console.log(err)
      }).finally(() =>{
        this.loading_selected_item = false
      })
    },  
    getData() {
      this.getVrtTransactions()
    },
    goToOrder(vrt_transaction){
      if(vrt_transaction?.solution == 'retail'){
        this.goToRetailPage(vrt_transaction?.external_order_id)
      }else{
        this.goToWholesaleDoneOrder(vrt_transaction?.order_id)
      }
    },
    emitData(){
      let data = {
        paying_vrts: this.paying_vrts,
        selected_vrts_ammount: this.selected_vrts_ammount,
        selected_vrts: this.selected_vrts,
        total_debt: this.total_debt,
      }
      this.$emit('onChange', data)
    },
    getVrtTransactions(){
      if(this.client_id){
        this.vrt_transactions = []
        this.selected_vrts = []
        this.loading.vrt_transactions = true
        let params = {
          client_id: this.client_id,
          transaction_type_ids: [9],
        }
        Api.VrtTransaction.defaultIndex(params).then(res => res.data).then(data => {
          this.vrt_transactions = data.data.map(vrt => ({
            ...vrt,
            isSelectable: vrt.attributes.pay_status === 'available',
          }))
        }).finally(()=>{
          this.loading.vrt_transactions = false
          this.emitData()
        })
      }
    },
  },
  watch:{
    client_id(){
      this.getVrtTransactions()
    },
    selected_vrts(nv){
      const payable = nv.filter(vrt => vrt.attributes.pay_status === 'available')
      if (payable.length !== nv.length) {
        this.selected_vrts = payable
        return
      }
      nv.forEach(vrt => {
        if (vrt.paying_juros === undefined || vrt.paying_juros === null || vrt.paying_juros === '') {
          this.$set(vrt, 'paying_juros', '0.00')
        }
      })
      this.emitData()
    }
  },
  mounted() {
    this.getData()
  },
}
</script>